import { render } from "./ClubsShow.vue?vue&type=template&id=2683b063&scoped=true"
import script from "./ClubsShow.vue?vue&type=script&lang=js"
export * from "./ClubsShow.vue?vue&type=script&lang=js"

import "./ClubsShow.vue?vue&type=style&index=0&id=2683b063&scoped=true&lang=css"

import exportComponent from "/Users/corrieleech/Actualize/booksmart-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2683b063"]])

export default __exports__